import { render } from "./AppSwiper.vue?vue&type=template&id=54b483d5&lang=pug"
import script from "./AppSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwiper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__